<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb" ></app-breadcrumb>

<div class="row clearfix">

      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Monthly Transaction Count</h6>
              <span>{{ profileDetails?.current_month_transaction_count || 0 }}</span>
            </div>
            <!--<small class="text-muted">19% compared to last week</small>-->
          </div>

        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Monthly Transaction Volume</h6>
              <span>{{ profileDetails?.current_month_transaction_volume || "--" }}</span>
            </div>
            <!--<small class="text-muted">19% compared to last week</small>-->
          </div>

        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Virtual Account Number </h6>
              <span>{{ profileDetails?.remittance?.van_account_number || '--'  }}</span>
            </div>
            <!--<small class="text-muted">19% compared to last week</small>-->
          </div>

        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Virtual Bank Name </h6>
              <span>{{ profileDetails?.remittance?.van_bank || "--" }}</span>
            </div>
            <!--<small class="text-muted">19% compared to last week</small>-->
          </div>

        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Virtual Account Reference </h6>
              <span>{{ profileDetails?.remittance?.van_reference || '--' }}</span>
            </div>
            <!--<small class="text-muted">19% compared to last week</small>-->
          </div>

        </div>
      </div>
     <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="card overflowhidden number-chart">
          <div class="body">
            <div class="number">
              <h6>Wallet Balance</h6>
              <span>{{ profileDetails?.wallet_balance || 0 | currency: '&#8358;'  }}</span>
            </div>
            <!-- &lt;!&ndash;<small class="text-muted">19% compared to last week</small>&ndash;&gt; -->
          </div>

        </div>
      </div>
    </div>
    <!-- <div class="row clearfix">


    </div> -->





  </div>
</div>
